import { render, staticRenderFns } from "./SelectDate.vue?vue&type=template&id=2c67daeb&scoped=true"
import script from "./SelectDate.vue?vue&type=script&lang=js"
export * from "./SelectDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67daeb",
  null
  
)

export default component.exports